import { motion } from "framer-motion";
import { CheckCircle2, Shield, Clock, Handshake } from "lucide-react";

const EngagementSection = () => {
  const engagements = [
    {
      icon: <Clock className="w-6 h-6" />,
      title: "Fiabilité des livraisons",
      description: "Respect des engagements et maîtrise des mises en production",
    },
    {
      icon: <Shield className="w-6 h-6" />,
      title: "Sécurité des systèmes",
      description: "Conformité aux standards grands comptes et protection des données",
    },
    {
      icon: <Handshake className="w-6 h-6" />,
      title: "Accompagnement dans la durée",
      description: "Suivi, amélioration continue et réduction du risque projet",
    }
  ];

  return (
    <section className="section-spacing relative">
      {/* Background - LIGHTER */}
      <div className="absolute inset-0 bg-[#070B1A]" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#070B1A] via-[#0C1225]/50 to-[#070B1A]" />
      
      <div className="lenvia-container relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="inline-flex items-center gap-2.5 mb-6"
          >
            <CheckCircle2 className="w-4 h-4 text-lenvia-success" />
            <span className="text-xs font-bold tracking-[0.2em] text-slate-400 uppercase">
              Notre engagement
            </span>
          </motion.div>
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="font-heading text-3xl md:text-4xl lg:text-[2.75rem] font-bold tracking-tight text-white mb-5"
          >
            Un cadre d'intervention adapté aux{" "}
            <span className="gradient-text">systèmes critiques</span>
          </motion.h2>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="text-base text-slate-400 max-w-2xl mx-auto"
          >
            Environnements à forte criticité et contraintes élevées
          </motion.p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {engagements.map((point, index) => (
            <motion.div
              key={point.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group"
            >
              <div className="glass-card p-8 h-full flex flex-col items-center text-center">
                {/* Icon */}
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-lenvia-success/18 to-lenvia-blue/12 border border-lenvia-success/25 flex items-center justify-center text-lenvia-success mb-6 group-hover:scale-110 transition-transform duration-300">
                  {point.icon}
                </div>
                
                {/* Content */}
                <h3 className="font-heading text-xl font-bold text-white mb-4">
                  {point.title}
                </h3>
                <p className="text-base text-slate-400 leading-relaxed">
                  {point.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EngagementSection;
